import { render, staticRenderFns } from "./ProjectSlider.vue?vue&type=template&id=06d2bb1c&"
import script from "./ProjectSlider.vue?vue&type=script&lang=js&"
export * from "./ProjectSlider.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSlider.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports